import * as ReactDOMClient from '..';

const createRoot = ReactDOMClient.createRoot;

export {
  createRoot,
};

export default ReactDOMClient;
